import { render, staticRenderFns } from "./IdeaMechanicalDetailed.vue?vue&type=template&id=27e7fb34&"
import script from "./IdeaMechanicalDetailed.vue?vue&type=script&lang=js&"
export * from "./IdeaMechanicalDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports